import React from 'react'
import InfoPortul from '../Layout/InforPortul'

const InfoPortulPage = () => {
  return <InfoPortul />
}

export default InfoPortulPage
